import { useState, useEffect } from 'react';

export default function useInitialLoader() {
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timeout);
  }, []);

  return initialLoading;
}
